export function showElement(element: HTMLElement, x: number, y: number) {
	Object.assign(element.style, {
		top: `${y}px`,
		left: `${x}px`,
	});
	requestAnimationFrame(() => {
		Object.assign(element.style, {
			opacity: 1,
		});
	});
}
